/**
 * 地块绘制工具
 */
import Base from "./Base";
import {TOOL_GRAFFITI} from "./ToolType";
import {TEMP_LAYER_NAME_GRAFFITI,TEMP_LAYER_NAME_GRAFFITI_LINE} from "./Constants";
import * as turf from '@turf/turf'
import * as helpers from '@turf/helpers'
import {checkKinks} from "../../common/CommonFun";


export default class Graffiti extends Base {
  constructor(options = {}) {
    let params={
      map:null,//地图实例
      showIcon: true,//是否展示图标
      iconCLassName: "iconfont-map map-icon-tuya",//图标类名
      callBackName: "",//正常地图事件回调
      errorEventName: "",//错误地图事件回调
      chineseName: "涂鸦",//中文工具名称
      continueDraw:true,//是否连续绘制
      checkValid:false,//是否检测自相交
      showArea:false,//是否实时展示面积
      callBack:null,
      errorCallBack:null,
      drawLineOnly:false,//true只绘制线，切不会自动闭合
    }
    Object.assign(params,options)
    super(params.map, TOOL_GRAFFITI, params);
    this.showArea=params.showArea;
    this.continueDraw=params.continueDraw;
    this.checkValid=params.checkValid;
    this.drawLineOnly=params.drawLineOnly;
  }

  start() {
    super.start();
    this.disableMap();
    this.coordinates = [];
    this.mousedownEvent = e => {
      this.mousedown(e)
    }
    this.map.on("mousedown", this.mousedownEvent);
    this.map.on("touchstart", this.mousedownEvent);
  }

  enableViewMap() {
    this.map.dragPan.enable();
    this.map.touchZoomRotate.enable();
    this.map.doubleClickZoom.enable();
  }

  disableMap() {
    // //禁止拖拽地图
    this.map.dragPan.disable();
    // //禁止通过捏合屏幕进行缩放
    this.map.touchZoomRotate.disable();
    // //禁止双击缩放
    this.map.doubleClickZoom.disable();
  }


  mousedown() {
    this.coordinates = [];
    //鼠标落下时添加鼠标移动和抬起监听
    this.mouseMoveEvent = (e) => {
      this.mousemove(e)
    }
    this.map.on("mousemove", this.mouseMoveEvent);
    this.map.on("touchmove", this.mouseMoveEvent);
    this.mouseUpEvent = (e) => {
      this.mouseup(e)
    }
    this.map.on("mouseup", this.mouseUpEvent);
    this.map.on("touchend", this.mouseUpEvent);
    this.addDrawLayer();
  }

  mousemove(e) {
    this.coordinates.push([e.lngLat.lng, e.lngLat.lat]);


    if(this.showArea&&this.coordinates.length>2){
      this.updateArea();
    }
    this.updateDrawLayer();
  }

  mouseup(e) {
    this.updateDrawLayer();
    this.map.off("mousemove", this.mouseMoveEvent);
    this.map.off("touchmove", this.mouseMoveEvent);
    this.map.off("mouseup", this.mouseUpEvent);
    this.map.off("touchend", this.mouseUpEvent);

    if(this.showArea){
      this.updateArea();
    }

    if(this.checkValid&&checkKinks(this._getFeature())){
      this.error("自相交")
    }else {
      this.finish(this._getFeature());
    }
    if(!this.continueDraw){
      this.inActiveIcon();
    }
  }

//添加绘制图层
  addDrawLayer() {
    let geoJson = helpers.featureCollection([]);
    if (!this.map.getSource(TEMP_LAYER_NAME_GRAFFITI)) {
      this.map.addSource(TEMP_LAYER_NAME_GRAFFITI, {
        type: "geojson",
        data: geoJson,
      });
    }

    if (!this.drawLineOnly&&!this.map.getLayer(TEMP_LAYER_NAME_GRAFFITI)) {
      this.map.addLayer({
        id: TEMP_LAYER_NAME_GRAFFITI,
        type: "fill",
        source: TEMP_LAYER_NAME_GRAFFITI,
        layout: {},
        paint: {
          "fill-color": "#F00",
          "fill-opacity": 0.3,
        },
      });
    }
    if (!this.map.getLayer(TEMP_LAYER_NAME_GRAFFITI_LINE)) {
      this.map.addLayer({
        id: TEMP_LAYER_NAME_GRAFFITI_LINE,
        type: "line",
        source: TEMP_LAYER_NAME_GRAFFITI,
        layout: {},
        paint: {
          "line-color": "#F00",
          "line-width": 5,
        },
      });
    }
  }

  updateDrawLayer() {
    if(this.coordinates.length>2){
      this.map.getSource(TEMP_LAYER_NAME_GRAFFITI).setData(this._getFeature());
    }
  }

  /**
   * 获取点组成的要素
   * @private
   */
  _getFeature(){
    let coordinates=[].concat(this.coordinates);
    if(!this.drawLineOnly){
      coordinates.push(this.coordinates[0]);
      return  helpers.polygon([coordinates]);
    }else {
      return  helpers.lineString(coordinates);
    }

  }

  //编辑地块
  updateArea() {
    if (this.coordinates.length > 0) {
      let feature=this._getFeature();
      let area = turf.area(feature);
      let center=turf.center(feature);
      this.addPopup((area*0.0015).toFixed(2)+"亩",center)
    }
  }


  close(notClearMap = false) {
    this.clear(notClearMap);
    this.clearEvent();
  }

  clear(notClearMap = false) {
    this.clearMap(notClearMap);
    this.enableViewMap();
  }

  clearMap(notClearMap = false) {
    //不清除地图选择绘制图层
    if (!notClearMap) {
      super.clearMap();
    }
    this.removeDrawLayer();
    this.clearPopup();
  }

  //移除绘制图层
  removeDrawLayer() {
    if (this.map.getLayer(TEMP_LAYER_NAME_GRAFFITI)) {
      this.map.removeLayer(TEMP_LAYER_NAME_GRAFFITI);
      this.map.removeLayer(TEMP_LAYER_NAME_GRAFFITI_LINE);
    }
    if (this.map.getSource(TEMP_LAYER_NAME_GRAFFITI)) {
      this.map.removeSource(TEMP_LAYER_NAME_GRAFFITI);
    }
  }

  clearEvent() {
    super.clearEvent();
    this.map.off("mousedown", this.mousedownEvent);
    this.map.off("mousemove", this.mouseMoveEvent);
    this.map.off("mouseup", this.mouseUpEvent);
    this.map.off("touchstart", this.mousedownEvent);
    this.map.off("touchmove", this.mouseMoveEvent);
    this.map.off("touchend", this.mouseUpEvent);
  }
}



// WEBPACK FOOTER //
// ./src/tool/edit/Graffiti.js